/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  DataResponseListCardRead,
  DefaultableCardType,
  ErrorResponse,
  GetActiveParticipantAccountPaymentAccountGetParams,
  HTTPValidationError,
  LockCardPaymentAccountLockPostParams,
  PaymentAccountCreate,
  PaymentAccountResponse,
  PaymentProvider,
  TransactionResponse,
  UnlockCardPaymentAccountUnlockPostParams,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * The participant's Default Payment Account, the account PPS pays.
 *
 * Read from PPS's latest payment account for the participant's country
 * (cached). `allowed_payable_types` states which Payable Item kinds it can
 * receive: a Stripe Stipend Card lists `stipend` and `micropayment` only, a
 * Spend Card can never be the default, every other account lists all four.
 * The participant app uses it to redirect the participant to another payment
 * method before a claim starts. The body is `null` when the participant has
 * no payment account yet.
 *
 * A participant gets their own. A User with Claims Create names the
 * participant with ``participant_id``, and PPH uses it to show whether a
 * claim can be raised for them.
 * @summary Get Active Participant Account
 */
export const getActiveParticipantAccountPaymentAccountGet = (
  params?: GetActiveParticipantAccountPaymentAccountGetParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<PaymentAccountResponse | null>(
    { url: `/payment-account`, method: "GET", params, signal },
    options
  );
};

export const getGetActiveParticipantAccountPaymentAccountGetQueryKey = (
  params?: GetActiveParticipantAccountPaymentAccountGetParams
) => {
  return [`/payment-account`, ...(params ? [params] : [])] as const;
};

export const getGetActiveParticipantAccountPaymentAccountGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetActiveParticipantAccountPaymentAccountGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetActiveParticipantAccountPaymentAccountGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>>
  > = ({ signal }) =>
    getActiveParticipantAccountPaymentAccountGet(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActiveParticipantAccountPaymentAccountGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>>
  >;
export type GetActiveParticipantAccountPaymentAccountGetQueryError = ErrorType<
  ErrorResponse | HTTPValidationError
>;

export function useGetActiveParticipantAccountPaymentAccountGet<
  TData = Awaited<
    ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params: undefined | GetActiveParticipantAccountPaymentAccountGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActiveParticipantAccountPaymentAccountGet<
  TData = Awaited<
    ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetActiveParticipantAccountPaymentAccountGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActiveParticipantAccountPaymentAccountGet<
  TData = Awaited<
    ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetActiveParticipantAccountPaymentAccountGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Active Participant Account
 */

export function useGetActiveParticipantAccountPaymentAccountGet<
  TData = Awaited<
    ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  params?: GetActiveParticipantAccountPaymentAccountGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getActiveParticipantAccountPaymentAccountGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetActiveParticipantAccountPaymentAccountGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a payment account or card for the participant through PPS.
 *
 * `payment_type` is one of the methods offered by `GET /payment-methods/ui`
 * (BANK_ACCOUNT, DEBIT_CARD, the Highnote cards VIRTUAL_CARD, PHYSICAL_CARD,
 * EXPENSE_CARD, PHYSICAL_EXPENSE_CARD or the Stripe cards
 * VIRTUAL_STIPEND_CARD, PHYSICAL_STIPEND_CARD, VIRTUAL_SPEND_CARD,
 * PHYSICAL_SPEND_CARD), each enabled per study country. For cards PASS records
 * the participant's acceptance of the card programme's legal documents once
 * PPS has created the card. When the participant has opted in to auto-accept
 * payments, their pending stipends and micropayments are then accepted on a
 * best-effort basis, and a failure there never fails the request. Stripe
 * answers 409 when an active card of the same type already exists; lock it
 * first. The PPS response is relayed.
 * @summary Create Payment Account
 */
export const createPaymentAccountPaymentAccountPost = (
  paymentAccountCreate: BodyType<PaymentAccountCreate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<unknown>(
    {
      url: `/payment-account`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: paymentAccountCreate,
      signal,
    },
    options
  );
};

export const getCreatePaymentAccountPaymentAccountPostMutationKey = () =>
  ["createPaymentAccountPaymentAccountPost"] as const;

export const getCreatePaymentAccountPaymentAccountPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPaymentAccountPaymentAccountPost>>,
    TError,
    CreatePaymentAccountPaymentAccountPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPaymentAccountPaymentAccountPost>>,
  TError,
  CreatePaymentAccountPaymentAccountPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreatePaymentAccountPaymentAccountPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPaymentAccountPaymentAccountPost>>,
    CreatePaymentAccountPaymentAccountPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createPaymentAccountPaymentAccountPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePaymentAccountPaymentAccountPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPaymentAccountPaymentAccountPost>>
>;
export type CreatePaymentAccountPaymentAccountPostMutationBody =
  BodyType<PaymentAccountCreate>;
export type CreatePaymentAccountPaymentAccountPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface CreatePaymentAccountPaymentAccountPostMutationVariables {
  data: BodyType<PaymentAccountCreate>;
}

/**
 * @summary Create Payment Account
 */
export const useCreatePaymentAccountPaymentAccountPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPaymentAccountPaymentAccountPost>>,
      TError,
      CreatePaymentAccountPaymentAccountPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPaymentAccountPaymentAccountPost>>,
  TError,
  CreatePaymentAccountPaymentAccountPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreatePaymentAccountPaymentAccountPostMutationOptions(options),
    queryClient
  );
};
/**
 * List the participant's transactions from PPS as a bare list.
 *
 * PPS returns every transaction for the participant across providers and
 * accounts. Stripe participants get one row per card authorization on every
 * card they hold plus one row per bank payout, so a client showing one card
 * filters on `payment_type`. Highnote rows carry no `payment_type`. See
 * `TransactionResponse` for both row shapes. Not paginated.
 * @summary Get Participant Transactions
 */
export const getParticipantTransactionsPaymentAccountCardTransactionsGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<TransactionResponse[]>(
    { url: `/payment-account/card/transactions`, method: "GET", signal },
    options
  );
};

export const getGetParticipantTransactionsPaymentAccountCardTransactionsGetQueryKey =
  () => {
    return [`/payment-account/card/transactions`] as const;
  };

export const getGetParticipantTransactionsPaymentAccountCardTransactionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
      >
    >,
    TError = ErrorType<ErrorResponse>,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetParticipantTransactionsPaymentAccountCardTransactionsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
        >
      >
    > = ({ signal }) =>
      getParticipantTransactionsPaymentAccountCardTransactionsGet(
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetParticipantTransactionsPaymentAccountCardTransactionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
      >
    >
  >;
export type GetParticipantTransactionsPaymentAccountCardTransactionsGetQueryError =
  ErrorType<ErrorResponse>;

export function useGetParticipantTransactionsPaymentAccountCardTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
    >
  >,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantTransactionsPaymentAccountCardTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
    >
  >,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantTransactionsPaymentAccountCardTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
    >
  >,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Participant Transactions
 */

export function useGetParticipantTransactionsPaymentAccountCardTransactionsGet<
  TData = Awaited<
    ReturnType<
      typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
    >
  >,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getParticipantTransactionsPaymentAccountCardTransactionsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetParticipantTransactionsPaymentAccountCardTransactionsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Every card the participant holds, across providers and card types.
 *
 * `card_type` is the structural discriminator (vc, pc, ec, pec for Highnote,
 * vstc, pstc, vspc, pspc for Stripe).
 * `balance` is passed through as PPS sends it and `null` means hidden: Spend
 * Cards, Expense Cards and read-only cards carry no balance and must not be
 * shown as 0.00. For Stripe cards `id` is the issuing card id needed by
 * Stripe.js to create the visualization nonce.
 * @summary List Cards
 */
export const listCardsPaymentAccountCardAllGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseListCardRead>(
    { url: `/payment-account/card/all`, method: "GET", signal },
    options
  );
};

export const getListCardsPaymentAccountCardAllGetQueryKey = () => {
  return [`/payment-account/card/all`] as const;
};

export const getListCardsPaymentAccountCardAllGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCardsPaymentAccountCardAllGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>
  > = ({ signal }) => listCardsPaymentAccountCardAllGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCardsPaymentAccountCardAllGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>
>;
export type ListCardsPaymentAccountCardAllGetQueryError =
  ErrorType<ErrorResponse>;

export function useListCardsPaymentAccountCardAllGet<
  TData = Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
          TError,
          Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCardsPaymentAccountCardAllGet<
  TData = Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
          TError,
          Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCardsPaymentAccountCardAllGet<
  TData = Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Cards
 */

export function useListCardsPaymentAccountCardAllGet<
  TData = Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCardsPaymentAccountCardAllGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListCardsPaymentAccountCardAllGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Deprecated alias of `GET /payment-account/card/all` returning the bare
 * list. PPS lists every card type here, not only virtual cards.
 * @deprecated
 * @summary List Virtual Cards
 */
export const listVirtualCardsPaymentAccountVcAllGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<unknown>(
    { url: `/payment-account/vc/all`, method: "GET", signal },
    options
  );
};

export const getListVirtualCardsPaymentAccountVcAllGetQueryKey = () => {
  return [`/payment-account/vc/all`] as const;
};

export const getListVirtualCardsPaymentAccountVcAllGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListVirtualCardsPaymentAccountVcAllGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>
  > = ({ signal }) =>
    listVirtualCardsPaymentAccountVcAllGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListVirtualCardsPaymentAccountVcAllGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>
>;
export type ListVirtualCardsPaymentAccountVcAllGetQueryError =
  ErrorType<ErrorResponse>;

export function useListVirtualCardsPaymentAccountVcAllGet<
  TData = Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
          TError,
          Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListVirtualCardsPaymentAccountVcAllGet<
  TData = Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
          TError,
          Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListVirtualCardsPaymentAccountVcAllGet<
  TData = Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @deprecated
 * @summary List Virtual Cards
 */

export function useListVirtualCardsPaymentAccountVcAllGet<
  TData = Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVirtualCardsPaymentAccountVcAllGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListVirtualCardsPaymentAccountVcAllGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Lock a card so it cannot be used. Any Card Type of either provider.
 *
 * Locking is also how a Stripe card is retired before a replacement of the
 * same type is created.
 * @summary Lock Card
 */
export const lockCardPaymentAccountLockPost = (
  params: LockCardPaymentAccountLockPostParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<void>(
    { url: `/payment-account/lock`, method: "POST", params, signal },
    options
  );
};

export const getLockCardPaymentAccountLockPostMutationKey = () =>
  ["lockCardPaymentAccountLockPost"] as const;

export const getLockCardPaymentAccountLockPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lockCardPaymentAccountLockPost>>,
    TError,
    LockCardPaymentAccountLockPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lockCardPaymentAccountLockPost>>,
  TError,
  LockCardPaymentAccountLockPostMutationVariables,
  TContext
> => {
  const mutationKey = getLockCardPaymentAccountLockPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lockCardPaymentAccountLockPost>>,
    LockCardPaymentAccountLockPostMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return lockCardPaymentAccountLockPost(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LockCardPaymentAccountLockPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof lockCardPaymentAccountLockPost>>
>;

export type LockCardPaymentAccountLockPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface LockCardPaymentAccountLockPostMutationVariables {
  params: LockCardPaymentAccountLockPostParams;
}

/**
 * @summary Lock Card
 */
export const useLockCardPaymentAccountLockPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof lockCardPaymentAccountLockPost>>,
      TError,
      LockCardPaymentAccountLockPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof lockCardPaymentAccountLockPost>>,
  TError,
  LockCardPaymentAccountLockPostMutationVariables,
  TContext
> => {
  return useMutation(
    getLockCardPaymentAccountLockPostMutationOptions(options),
    queryClient
  );
};
/**
 * Unlock a previously locked card. Any Card Type of either provider.
 * @summary Unlock Card
 */
export const unlockCardPaymentAccountUnlockPost = (
  params: UnlockCardPaymentAccountUnlockPostParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<void>(
    { url: `/payment-account/unlock`, method: "POST", params, signal },
    options
  );
};

export const getUnlockCardPaymentAccountUnlockPostMutationKey = () =>
  ["unlockCardPaymentAccountUnlockPost"] as const;

export const getUnlockCardPaymentAccountUnlockPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unlockCardPaymentAccountUnlockPost>>,
    TError,
    UnlockCardPaymentAccountUnlockPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unlockCardPaymentAccountUnlockPost>>,
  TError,
  UnlockCardPaymentAccountUnlockPostMutationVariables,
  TContext
> => {
  const mutationKey = getUnlockCardPaymentAccountUnlockPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unlockCardPaymentAccountUnlockPost>>,
    UnlockCardPaymentAccountUnlockPostMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return unlockCardPaymentAccountUnlockPost(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnlockCardPaymentAccountUnlockPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof unlockCardPaymentAccountUnlockPost>>
>;

export type UnlockCardPaymentAccountUnlockPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface UnlockCardPaymentAccountUnlockPostMutationVariables {
  params: UnlockCardPaymentAccountUnlockPostParams;
}

/**
 * @summary Unlock Card
 */
export const useUnlockCardPaymentAccountUnlockPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unlockCardPaymentAccountUnlockPost>>,
      TError,
      UnlockCardPaymentAccountUnlockPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof unlockCardPaymentAccountUnlockPost>>,
  TError,
  UnlockCardPaymentAccountUnlockPostMutationVariables,
  TContext
> => {
  return useMutation(
    getUnlockCardPaymentAccountUnlockPostMutationOptions(options),
    queryClient
  );
};
/**
 * Make this card the participant's Default Payment Account, the account
 * PPS pays.
 *
 * Only `vc`, `pc`, `vstc` and `pstc` are accepted; Expense Cards and Spend
 * Cards never receive a payout and are rejected with 422 at the route. A
 * Stripe Stipend Card is accepted but receives stipends and micropayments
 * only, so while it is the default every receipt and mileage claim is refused
 * with 422 `PMT-05` and the participant must choose another payment method.
 * @summary Set Default Card
 */
export const setDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPost =
  (
    paymentMethodType: DefaultableCardType,
    provider: PaymentProvider,
    options?: SecondParameter<typeof nmibleInstanceV3>,
    signal?: AbortSignal
  ) => {
    return nmibleInstanceV3<void>(
      {
        url: `/payment-account/${paymentMethodType}/${provider}/default`,
        method: "POST",
        signal,
      },
      options
    );
  };

export const getSetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationKey =
  () =>
    [
      "setDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPost",
    ] as const;

export const getSetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPost
        >
      >,
      TError,
      SetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPost
      >
    >,
    TError,
    SetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationVariables,
    TContext
  > => {
    const mutationKey =
      getSetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPost
        >
      >,
      SetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationVariables
    > = (props) => {
      const { paymentMethodType, provider } = props ?? {};

      return setDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPost(
        paymentMethodType,
        provider,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPost
      >
    >
  >;

export type SetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface SetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationVariables {
  paymentMethodType: DefaultableCardType;
  provider: PaymentProvider;
}

/**
 * @summary Set Default Card
 */
export const useSetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPost =
  <TError = ErrorType<ErrorResponse | HTTPValidationError>, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPost
          >
        >,
        TError,
        SetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationVariables,
        TContext
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPost
      >
    >,
    TError,
    SetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationVariables,
    TContext
  > => {
    return useMutation(
      getSetDefaultCardPaymentAccountPaymentMethodTypeProviderDefaultPostMutationOptions(
        options
      ),
      queryClient
    );
  };
